import { faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

/** Map Fontawesome icon. */
const fontawesomeMap = {
  outline: {},

  fill: {
    xTwitter: faXTwitter,
    youtube: faYoutube,
  },
};

export default fontawesomeMap;
